import React from 'react';
import BonusAllowanceRow from './BonusAllowanceRow';
import { useTranslation } from 'react-i18next';

const BonusAllowancesTable = ({ allowances, handleDeleteRow }) => {
  const { t } = useTranslation();
  return (
    <div className="l-overflow-scroll">
      <table className="m-table-list m-table-fixed">
        <colgroup>
          <col width={200} />
          <col width={500} />
          <col width={100} />
        </colgroup>
        <thead>
          <tr>
            <th>{t('features.ClientBonusAllowances.components.BonusAllowancesTable.item_name')}</th>
            <th>{t('features.ClientBonusAllowances.components.BonusAllowancesTable.amount')}</th>
            <th width="100" />
          </tr>
        </thead>
        <tbody>
          {(!allowances || allowances.length === 0) && (
            <tr>
              <td colSpan={2}>{t('features.EmployeeBonus.components.EmployeeBonusTable.no_data')}</td>
            </tr>
          )}

          {allowances &&
            allowances.length > 0 &&
            allowances.map(allowance => (
              <BonusAllowanceRow key={allowance.id} allowance={allowance} handleDeleteRow={handleDeleteRow} />
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default BonusAllowancesTable;
